/* COFFEE CROPS — extra interaction layer: decorative parallax, magnetic buttons,
   scroll progress, "Find your cup", origins globe, brew guide. No dependencies. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  var vh = window.innerHeight;

  /* ---------- shared scroll loop ---------- */
  var scrollFns = [], ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; vh = window.innerHeight; scrollFns.forEach(function (f) { f(); }); });
  }
  doc.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ---------- scroll progress ---------- */
  function scroller() {
    var pw = doc.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 4 && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)) return pw;
    return doc.scrollingElement || root;
  }
  function initProgress() {
    if (doc.querySelector('.cc-progress')) return;
    var bar = doc.createElement('div'); bar.className = 'cc-progress'; bar.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(bar);
    scrollFns.push(function () {
      var sc = scroller(), max = sc.scrollHeight - sc.clientHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? clamp(sc.scrollTop / max, 0, 1) : 0).toFixed(4) + ')';
    });
  }

  /* ---------- decorative line-art parallax ---------- */
  var decos = [];
  function initDeco(ctx) {
    $$('[data-cc-deco]', ctx).forEach(function (d) { if (!d._cc) { d._cc = 1; decos.push(d); } });
  }
  scrollFns.push(function () {
    if (reduce.matches) return;
    decos.forEach(function (d) {
      var r = d.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) return;
      d.style.setProperty('--sp', (-(r.top + r.height / 2 - vh / 2) / vh).toFixed(3));
    });
  });
  var mq = false;
  window.addEventListener('pointermove', function (e) {
    if (!fine.matches || reduce.matches || mq) return; mq = true;
    requestAnimationFrame(function () {
      mq = false;
      root.style.setProperty('--cc-mx', ((e.clientX / window.innerWidth) * 2 - 1).toFixed(3));
      root.style.setProperty('--cc-my', ((e.clientY / window.innerHeight) * 2 - 1).toFixed(3));
    });
  }, { passive: true });

  /* ---------- magnetic buttons ---------- */
  function initMagnetic(ctx) {
    $$('.cc-btn', ctx).forEach(function (b) {
      if (b._ccMag) return; b._ccMag = 1;
      b.addEventListener('pointermove', function (e) {
        if (!fine.matches || reduce.matches) return;
        var r = b.getBoundingClientRect();
        b.style.setProperty('--mg-x', (((e.clientX - r.left) / r.width - 0.5) * 12).toFixed(1) + 'px');
        b.style.setProperty('--mg-y', (((e.clientY - r.top) / r.height - 0.5) * 10).toFixed(1) + 'px');
      });
      b.addEventListener('pointerleave', function () { b.style.setProperty('--mg-x', '0px'); b.style.setProperty('--mg-y', '0px'); });
    });
  }

  /* ---------- Find your cup ---------- */
  function initFlavour(ctx) {
    $$('[data-cc-flavour]', ctx).forEach(function (sec) {
      if (sec._cc) return; sec._cc = 1;
      var tabs = $$('[data-cc-fl-tab]', sec), imgs = $$('[data-cc-fl-img]', sec);
      var sets = $$('[data-cc-fl-noteset]', sec), panels = $$('[data-cc-fl-panel]', sec);
      var ghost = sec.querySelector('[data-cc-fl-ghost]'), count = sec.querySelector('[data-cc-fl-count]');
      var cur = 0, prevTimer = 0;
      if ('IntersectionObserver' in window) {
        var eio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { $$('img', sec).forEach(function (im) { im.loading = 'eager'; }); eio.disconnect(); } }, { rootMargin: '400px 0px' });
        eio.observe(sec);
      }
      function go(i, focus) {
        i = (i + tabs.length) % tabs.length;
        if (i === cur) { if (focus) tabs[i].focus(); return; }
        tabs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
        imgs.forEach(function (m, k) { m.classList.remove('is-prev'); if (k === cur) m.classList.add('is-prev'); m.classList.toggle('is-active', k === i); });
        clearTimeout(prevTimer);
        prevTimer = setTimeout(function () { imgs.forEach(function (m) { m.classList.remove('is-prev'); }); }, 1200);
        sets.forEach(function (n, k) { n.classList.toggle('is-active', k === i); });
        panels.forEach(function (p, k) { var on = k === i; p.hidden = !on; p.classList.toggle('is-active', on); });
        sec.style.setProperty('--fl-tint', tabs[i].dataset.tint || '');
        if (ghost) { ghost.classList.remove('is-swap'); void ghost.offsetWidth; ghost.textContent = tabs[i].dataset.word || ''; ghost.classList.add('is-swap'); }
        if (count) count.textContent = (i < 9 ? '0' : '') + (i + 1);
        cur = i; if (focus) tabs[i].focus();
        if (tabs[i].scrollIntoView && sec.querySelector('.cc-flavour__tabs').scrollWidth > sec.querySelector('.cc-flavour__tabs').clientWidth) {
          var bar = sec.querySelector('.cc-flavour__tabs');
          bar.scrollTo({ left: tabs[i].offsetLeft - 20, behavior: reduce.matches ? 'auto' : 'smooth' });
        }
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { go(k); });
        t.addEventListener('keydown', function (e) {
          var key = e.key;
          if (key === 'ArrowRight' || key === 'ArrowDown') { e.preventDefault(); go(cur + 1, true); }
          else if (key === 'ArrowLeft' || key === 'ArrowUp') { e.preventDefault(); go(cur - 1, true); }
          else if (key === 'Home') { e.preventDefault(); go(0, true); }
          else if (key === 'End') { e.preventDefault(); go(tabs.length - 1, true); }
        });
      });
      sec.addEventListener('shopify:block:select', function (e) { var k = tabs.indexOf(e.target); if (k > -1) go(k); });
      var stage = sec.querySelector('[data-cc-fl-stage]'), frame = sec.querySelector('[data-cc-fl-tilt]');
      if (stage && frame) {
        stage.addEventListener('pointermove', function (e) {
          if (!fine.matches || reduce.matches) return;
          var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          frame.style.setProperty('--tx', (x * 7).toFixed(2) + 'deg'); frame.style.setProperty('--ty', (-y * 7).toFixed(2) + 'deg');
          frame.style.setProperty('--gx', ((x + 0.5) * 100).toFixed(1) + '%'); frame.style.setProperty('--gy', ((y + 0.5) * 100).toFixed(1) + '%');
        });
        stage.addEventListener('pointerleave', function () { frame.style.setProperty('--tx', '0deg'); frame.style.setProperty('--ty', '0deg'); });
      }
    });
  }

  /* ---------- Origins globe ---------- */
  var LAND = ',0s02,0u020y01,0v022101,0x03,0y033301,100331013901,11043e01,120637023j01,13063904,1507230333023c05,1608250436053c08,17092606390f,180927073a0g,1a0929072l013d0h,1a0a1l0129092l023e0g,1b0c2a092n023i0d,1b0d2b0a2p023m0b,1b0f2c0c2q023p053w02,1a0g2c0d2s013q013s033x014801,1a0i2f0c3v01,1a0i2e0c4201,1a0k2f0c3m0240024301,190k2e0d3k013z044401,1a0i2f0d3j033p023v023y05,190e1o012e0f3j013n043s013x01,1a0d2e0g3j013n053u01,1a0c2e0h3h013j013p02,1b0a25042c0j3g013j013q01,1a09230s39013s02,17011b06230t37013k013s01,1502200r35023c013f013h033o013q01,1304200t34033f04,0z051v011z0o2p0432043b063m01,0x0412021a021z0n2n0731053a053g01,0w03120117011x0n2l082z063708,0v041x0l2k082w0k,0t0514011v0l2h062o012q022t0l,0r0714011w0p2m0s,0p0912011v0m2i0s,0p0e1u0925022b0x3b01,0n0f1t06290w3a01,0m0g1u04270v34013801,0k0h1o031z01210w3001,0k0h1n031v011x01200v2w02,0i0i1k051r011t04210v2y01,0i0j1m091x0x,0h0i1i172q01,0g0i10011i16,0f0k1d021g132m01,0e0j1a011g0x2i01,0c0b0q0418011d011f0t2d02,05020b0a0p03150118011a011d0r,0304080b0n021503190u2402,040f0k010n010r021302160w,030g0k020p020u021104160r,0001030f0j020n030z04140n,030307020a020g020k050v03120h1k01,08030c040j040x0110081a01,07010g040t010x03,07020d050u02';
  var DEG = Math.PI / 180, land = null;
  function landPts() {
    if (land) return land;
    land = [];
    LAND.split(',').forEach(function (row, r) {
      var lat = -56 + r * 2.2, cl = Math.cos(lat * DEG), sl = Math.sin(lat * DEG);
      var cnt = Math.floor(360 / (2.2 / Math.max(cl, 0.2))), dl = 360 / cnt, off = r % 2 ? dl / 2 : 0;
      for (var i = 0; i + 4 <= row.length; i += 4) {
        var a = parseInt(row.substr(i, 2), 36), n = parseInt(row.substr(i + 2, 2), 36);
        for (var k = a; k < a + n; k++) land.push([cl, sl, (-180 + k * dl + off) * DEG]);
      }
    });
    return land;
  }
  function initGlobes(ctx) {
    $$('[data-cc-origins]', ctx).forEach(function (sec) {
      if (sec._cc) return; sec._cc = 1;
      var wrap = sec.querySelector('[data-cc-globe]'); if (!wrap) return;
      var canvas = wrap.querySelector('canvas'), g = canvas.getContext('2d');
      var tag = wrap.querySelector('[data-cc-globe-tag]'), tagLabel = wrap.querySelector('[data-cc-globe-label]');
      var btns = $$('[data-cc-origin]', sec);
      var pins = btns.map(function (b) { return { lat: +b.dataset.lat || 0, lon: +b.dataset.lon || 0, label: b.dataset.label }; });
      var home = { lat: parseFloat(sec.dataset.homeLat), lon: parseFloat(sec.dataset.homeLon), label: sec.dataset.homeLabel || '' };
      var hasHome = !isNaN(home.lat) && !isNaN(home.lon);
      var pts = landPts();
      var active = 0, cLon = pins.length ? pins[0].lon : 30, cLat = 12, tLon = cLon, tLat = 12;
      var dragX = 0, dragY = 0, dragging = false, lastInteract = 0, sx = 0, sy = 0, sLon = 0, sLat = 0;
      var W = 0, H = 0, R = 0, dpr = 1, running = false, visible = false, t0 = performance.now();
      var cLand = '222,209,194', cAccent = '176,120,82';

      function size() {
        var r = canvas.getBoundingClientRect(); dpr = Math.min(window.devicePixelRatio || 1, 2);
        W = Math.round(r.width * dpr); H = Math.round(r.height * dpr); canvas.width = W; canvas.height = H; R = Math.min(W, H) * 0.42;
      }
      function proj(lat, lon, alt) {
        var la = lat * DEG, lo = lon * DEG - cLon * DEG, t = cLat * DEG, k = 1 + (alt || 0);
        var x = Math.cos(la) * Math.sin(lo), y = Math.sin(la), z = Math.cos(la) * Math.cos(lo);
        var y2 = y * Math.cos(t) - z * Math.sin(t), z2 = y * Math.sin(t) + z * Math.cos(t);
        return { x: W / 2 + R * k * x, y: H / 2 - R * k * y2, z: z2, k: k };
      }
      function slerp(a, b, f) {
        var la1 = a.lat * DEG, lo1 = a.lon * DEG, la2 = b.lat * DEG, lo2 = b.lon * DEG;
        var p1 = [Math.cos(la1) * Math.cos(lo1), Math.cos(la1) * Math.sin(lo1), Math.sin(la1)];
        var p2 = [Math.cos(la2) * Math.cos(lo2), Math.cos(la2) * Math.sin(lo2), Math.sin(la2)];
        var d = Math.acos(clamp(p1[0] * p2[0] + p1[1] * p2[1] + p1[2] * p2[2], -1, 1)) || 1e-6;
        var A = Math.sin((1 - f) * d) / Math.sin(d), B = Math.sin(f * d) / Math.sin(d);
        var x = A * p1[0] + B * p2[0], y = A * p1[1] + B * p2[1], z = A * p1[2] + B * p2[2];
        return { lat: Math.atan2(z, Math.sqrt(x * x + y * y)) / DEG, lon: Math.atan2(y, x) / DEG };
      }
      function draw(now) {
        var t = (now - t0) / 1000;
        g.clearRect(0, 0, W, H);
        var cx = W / 2, cy = H / 2;
        var grd = g.createRadialGradient(cx - R * 0.35, cy - R * 0.4, R * 0.1, cx, cy, R);
        grd.addColorStop(0, 'rgba(' + cAccent + ',0.20)'); grd.addColorStop(0.65, 'rgba(' + cAccent + ',0.06)'); grd.addColorStop(1, 'rgba(0,0,0,0)');
        g.beginPath(); g.arc(cx, cy, R, 0, Math.PI * 2); g.fillStyle = grd; g.fill();
        g.lineWidth = dpr; g.strokeStyle = 'rgba(' + cLand + ',0.16)'; g.stroke();
        /* graticule */
        g.lineWidth = 0.6 * dpr; g.strokeStyle = 'rgba(' + cLand + ',0.07)';
        var la, lo, p, first;
        for (lo = -180; lo < 180; lo += 30) { g.beginPath(); first = true; for (la = -88; la <= 88; la += 4) { p = proj(la, lo); if (p.z > 0) { if (first) { g.moveTo(p.x, p.y); first = false; } else g.lineTo(p.x, p.y); } else first = true; } g.stroke(); }
        for (la = -60; la <= 60; la += 30) { g.beginPath(); first = true; for (lo = -180; lo <= 180; lo += 4) { p = proj(la, lo); if (p.z > 0) { if (first) { g.moveTo(p.x, p.y); first = false; } else g.lineTo(p.x, p.y); } else first = true; } g.stroke(); }
        /* land dots */
        var cl0 = cLon * DEG, tt = cLat * DEG, ct = Math.cos(tt), st = Math.sin(tt), s = 1.25 * dpr;
        for (var i = 0; i < pts.length; i++) {
          var q = pts[i], lo2 = q[2] - cl0, x = q[0] * Math.sin(lo2), z = q[0] * Math.cos(lo2);
          var y2 = q[1] * ct - z * st, z2 = q[1] * st + z * ct;
          if (z2 < -0.05) { g.globalAlpha = 0.05; } else { g.globalAlpha = 0.18 + 0.62 * Math.max(z2, 0); }
          g.fillStyle = 'rgb(' + cLand + ')';
          var px = cx + R * x, py = cy - R * y2, sz = z2 > 0 ? s * (0.7 + 0.5 * z2) : s * 0.6;
          g.fillRect(px - sz / 2, py - sz / 2, sz, sz);
        }
        g.globalAlpha = 1;
        /* arcs to home */
        if (hasHome) {
          pins.forEach(function (pin, k) {
            var on = k === active; g.beginPath(); var started = false;
            for (var f = 0; f <= 1.0001; f += 0.025) {
              var m = slerp(pin, home, f), q2 = proj(m.lat, m.lon, Math.sin(Math.PI * f) * 0.22);
              var vis = q2.z > 0 || Math.hypot(q2.x - cx, q2.y - cy) > R;
              if (vis) { if (!started) { g.moveTo(q2.x, q2.y); started = true; } else g.lineTo(q2.x, q2.y); } else started = false;
            }
            g.setLineDash([4 * dpr, 6 * dpr]); g.lineDashOffset = reduce.matches ? 0 : -t * 18 * dpr;
            g.lineWidth = (on ? 1.6 : 1) * dpr; g.strokeStyle = 'rgba(' + cAccent + ',' + (on ? 0.95 : 0.35) + ')'; g.stroke();
          });
          g.setLineDash([]);
          var hp = proj(home.lat, home.lon);
          if (hp.z > 0) {
            g.beginPath(); g.arc(hp.x, hp.y, 3.2 * dpr, 0, Math.PI * 2); g.fillStyle = 'rgb(' + cLand + ')'; g.fill();
            g.font = '500 ' + (10 * dpr) + 'px Poppins, system-ui, sans-serif'; g.fillStyle = 'rgba(' + cLand + ',0.8)';
            g.textAlign = 'left'; g.textBaseline = 'middle'; g.fillText(home.label.toUpperCase(), hp.x + 8 * dpr, hp.y);
          }
        }
        /* pins */
        var tagPos = null;
        pins.forEach(function (pin, k) {
          var q3 = proj(pin.lat, pin.lon); if (q3.z <= 0) return;
          var on = k === active;
          if (on && !reduce.matches) {
            var ph = (t % 2) / 2;
            g.beginPath(); g.arc(q3.x, q3.y, (6 + ph * 18) * dpr, 0, Math.PI * 2);
            g.strokeStyle = 'rgba(' + cAccent + ',' + (0.7 * (1 - ph)).toFixed(3) + ')'; g.lineWidth = 1.2 * dpr; g.stroke();
          }
          g.beginPath(); g.arc(q3.x, q3.y, (on ? 5.5 : 3.6) * dpr, 0, Math.PI * 2);
          g.fillStyle = on ? 'rgb(' + cAccent + ')' : 'rgba(' + cAccent + ',0.7)'; g.fill();
          g.lineWidth = 1.5 * dpr; g.strokeStyle = 'rgba(38,23,23,0.9)'; g.stroke();
          if (on) tagPos = { x: q3.x / dpr, y: q3.y / dpr };
        });
        if (tag) {
          if (tagPos) { tag.classList.remove('is-hidden'); tag.style.transform = 'translate(' + (tagPos.x + 14).toFixed(1) + 'px,' + (tagPos.y - 16).toFixed(1) + 'px)'; }
          else tag.classList.add('is-hidden');
        }
      }
      function step(now) {
        if (!running) return;
        var idle = now - lastInteract > 3500;
        if (!dragging) {
          var drift = (reduce.matches || !idle) ? 0 : Math.sin((now - t0) / 5200) * 18;
          if (idle) { dragX *= 0.94; dragY *= 0.94; }
          var goalLon = tLon + drift + dragX, goalLat = clamp(tLat + dragY, -50, 60);
          var dl = ((goalLon - cLon + 540) % 360) - 180;
          cLon += dl * (reduce.matches ? 1 : 0.06); cLat += (goalLat - cLat) * (reduce.matches ? 1 : 0.06);
        }
        draw(now);
        if (reduce.matches && !dragging) { running = false; return; }
        requestAnimationFrame(step);
      }
      function kick() { if (!running && visible) { running = true; requestAnimationFrame(step); } }
      function select(k) {
        active = k; tLon = pins[k].lon; tLat = clamp(pins[k].lat * 0.6 + 8, -40, 50); dragX = 0; dragY = 0;
        btns.forEach(function (b, j) { b.setAttribute('aria-expanded', j === k ? 'true' : 'false'); b.closest('.cc-origin').classList.toggle('is-active', j === k); });
        if (tagLabel) tagLabel.textContent = pins[k].label;
        lastInteract = 0; kick();
      }
      btns.forEach(function (b, k) { b.addEventListener('click', function () { select(k); }); });
      sec.addEventListener('shopify:block:select', function (e) { var k = btns.indexOf(e.target.querySelector && e.target.querySelector('[data-cc-origin]')); if (k > -1) select(k); });
      wrap.addEventListener('pointerdown', function (e) {
        dragging = true; wrap.classList.add('is-dragging'); sx = e.clientX; sy = e.clientY; sLon = dragX; sLat = dragY;
        if (wrap.setPointerCapture) wrap.setPointerCapture(e.pointerId);
        visible = true; kick();
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var k = 180 / (R / dpr * Math.PI);
        dragX = sLon - (e.clientX - sx) * k; dragY = sLat + (e.clientY - sy) * k * 0.6;
        var goalLon = tLon + dragX, dl = ((goalLon - cLon + 540) % 360) - 180; cLon += dl; cLat = clamp(tLat + dragY, -50, 60);
        lastInteract = performance.now();
      });
      function end() { if (!dragging) return; dragging = false; wrap.classList.remove('is-dragging'); lastInteract = performance.now(); kick(); }
      wrap.addEventListener('pointerup', end); wrap.addEventListener('pointercancel', end);
      size(); select(0); draw(performance.now());
      if ('ResizeObserver' in window) new ResizeObserver(function () { size(); draw(performance.now()); }).observe(canvas);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) kick(); else running = false; }, { rootMargin: '100px' }).observe(wrap);
      } else { visible = true; kick(); }
    });
  }

  /* ---------- Brew guide ---------- */
  function fmt(t) { t = Math.max(0, Math.floor(t)); var s = t % 60; return Math.floor(t / 60) + ':' + (s < 10 ? '0' : '') + s; }
  function initBrew(ctx) {
    $$('[data-cc-brew]', ctx).forEach(function (sec) {
      if (sec._cc) return; sec._cc = 1;
      var q = function (s) { return sec.querySelector(s); };
      var ratio = +sec.dataset.ratio || 15, bf = +sec.dataset.bloom || 3, TOTAL = +sec.dataset.total || 195;
      var input = q('[data-cc-brew-input]'), outW = q('[data-cc-brew-water]'), outC = q('[data-cc-brew-coffee]'), outB = q('[data-cc-brew-bloom]');
      var steps = $$('[data-cc-brew-step]', sec), ring = q('[data-cc-brew-ring]'), timeEl = q('[data-cc-brew-time]');
      var phaseEl = q('[data-cc-brew-phase]'), pourEl = q('[data-cc-brew-pour]'), startBtn = q('[data-cc-brew-start]');
      var startLbl = q('[data-cc-brew-start-label]'), resetBtn = q('[data-cc-brew-reset]'), live = q('[data-cc-brew-live]');
      var idleLabel = phaseEl ? phaseEl.textContent : '', doneLabel = phaseEl ? (phaseEl.dataset.done || 'Enjoy') : '';
      var water = 300, coffee = 20, bloom = 60, running = false, elapsed = 0, lastTs = 0, activeIdx = -2;
      function targetFor(i) {
        if (i < 0) return 0;
        var to = +steps[i].dataset.to;
        if (to) return Math.round(water * to / 100);
        return i === 0 ? bloom : targetFor(i - 1);
      }
      function calc() {
        water = +input.value; coffee = Math.round(water / ratio); bloom = coffee * bf;
        if (outW) outW.textContent = water; if (outC) outC.textContent = coffee; if (outB) outB.textContent = bloom;
        input.style.setProperty('--fill', ((water - +input.min) / (+input.max - +input.min) * 100).toFixed(1) + '%');
        steps.forEach(function (st, i) {
          var p = st.querySelector('[data-tpl]'); if (!p) return;
          p.textContent = p.dataset.tpl.replace(/\{bloom\}/g, bloom).replace(/\{water\}/g, water).replace(/\{coffee\}/g, coffee).replace(/\{to\}/g, targetFor(i));
        });
        render();
      }
      function stepAt(t) { var idx = 0; steps.forEach(function (st, i) { if (t >= +st.dataset.at) idx = i; }); return idx; }
      function render() {
        if (timeEl) timeEl.textContent = fmt(elapsed);
        if (ring) ring.style.strokeDashoffset = (1000 - 1000 * Math.min(1, elapsed / TOTAL)).toFixed(1);
        var started = running || elapsed > 0, idx = started ? stepAt(elapsed) : -1, finished = elapsed >= TOTAL;
        steps.forEach(function (st, i) {
          var s0 = +st.dataset.at, s1 = i < steps.length - 1 ? +steps[i + 1].dataset.at : TOTAL;
          st.classList.toggle('is-active', i === idx && !finished); st.classList.toggle('is-done', finished || (idx > -1 && i < idx));
          st.style.setProperty('--p', started ? clamp((elapsed - s0) / Math.max(1, s1 - s0), 0, 1).toFixed(3) : 0);
        });
        if (idx !== activeIdx || finished) {
          activeIdx = idx;
          if (phaseEl) phaseEl.textContent = finished ? doneLabel : (idx > -1 ? steps[idx].dataset.label : idleLabel);
          if (live && idx > -1 && !finished) { var tx = steps[idx].querySelector('[data-tpl]'); live.textContent = steps[idx].dataset.label + '. ' + (tx ? tx.textContent : ''); }
          if (live && finished) live.textContent = doneLabel;
        }
        if (pourEl) {
          if (idx < 0) pourEl.textContent = 0;
          else {
            var st2 = steps[idx], a0 = +st2.dataset.at, a1 = idx < steps.length - 1 ? +steps[idx + 1].dataset.at : TOTAL;
            var from = targetFor(idx - 1), to2 = targetFor(idx), dur = idx === 0 ? 10 : Math.max(1, (a1 - a0) * 0.8);
            pourEl.textContent = Math.round(from + (to2 - from) * clamp((elapsed - a0) / dur, 0, 1));
          }
        }
      }
      function label(k) { if (startLbl) startLbl.textContent = startLbl.dataset[k] || startLbl.textContent; }
      var timer = 0;
      function tick() {
        if (!running) return;
        var now = performance.now(); elapsed += (now - lastTs) / 1000; lastTs = now;
        if (elapsed >= TOTAL) { elapsed = TOTAL; running = false; clearInterval(timer); sec.classList.remove('is-running', 'is-paused'); sec.classList.add('is-finished'); label('start'); }
        render();
      }
      startBtn && startBtn.addEventListener('click', function () {
        if (running) { running = false; clearInterval(timer); sec.classList.remove('is-running'); sec.classList.add('is-paused'); label('resume'); return; }
        if (elapsed >= TOTAL) { elapsed = 0; activeIdx = -2; }
        running = true; lastTs = performance.now(); sec.classList.add('is-running'); sec.classList.remove('is-paused', 'is-finished'); label('pause');
        clearInterval(timer); timer = setInterval(tick, 200); render();
      });
      resetBtn && resetBtn.addEventListener('click', function () {
        running = false; clearInterval(timer); elapsed = 0; activeIdx = -2; sec.classList.remove('is-running', 'is-paused', 'is-finished'); label('start'); render();
      });
      input && input.addEventListener('input', calc);
      if (input) calc();
    });
  }

  function init(ctx) {
    ctx = ctx || doc;
    initProgress(); initDeco(ctx); initMagnetic(ctx); initFlavour(ctx); initGlobes(ctx); initBrew(ctx);
    onScroll();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  doc.addEventListener('shopify:section:load', function (e) {
    decos = decos.filter(function (d) { return doc.body.contains(d); });
    init(e.target);
  });
})();
